import { loadAdvancedSearchQueryActions } from "@coveo/headless";
import { useEffect, useState } from "react";

const Tab = ({ controller, jsonData, engine, children }) => {
	const [state, setState] = useState(controller.state);
	useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);

	const setAq = (selectedTab) => {
		const tabJson = jsonData.tabs[selectedTab];

		if (selectedTab === "All") {
			const action = loadAdvancedSearchQueryActions(engine).updateAdvancedSearchQueries({
				aq: jsonData.aq
			});

			engine.dispatch(action);
			controller.select();
		} else {
			const action = loadAdvancedSearchQueryActions(engine).updateAdvancedSearchQueries({
				aq: tabJson.tabFacet + jsonData.aq
			});

			engine.dispatch(action);
			controller.select();
		}
	};

	return (
		<button
			className={"newsroom-bar-tab " + (state.isActive === true ? "selected" : "")}
			disabled={state.isActive}
			onClick={() => setAq(children)}
			aria-label={children}
			data-a="true"
			data-a-lbl={children}
			data-a-cat="Coveo"
			data-a-act={`Filter | ${children}`}
		>
			{children}
		</button>
	);
};

export default Tab;
